<template>
    <div class="">
        <div class="banners">
            <div class="main-container">
                <div class="layout-wrapper">
                    <div class="sidebar">
                        <Sidebar ref="sidebarRef" @sidebar-toggled="handleSidebarToggle" />
                    </div>
                    
                    <div class="content main-content-wrapper" :class="{ 'sidebar-expanded': isSidebarOpen }" @click="hideSubsidebar()">
                        <TopHeader />
                        <div class="row m-0">
                            <div class="col p-4"> 
                                <router-view />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from '../components/MainSidebar.vue';
import TopHeader from '../components/TopHeader.vue'; // <--- Import it

export default {
    components: {
        Sidebar,
        TopHeader, // <--- Register it
    },
    data() {
        return {
            isSidebarOpen: window.innerWidth >= 992 
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        handleSidebarToggle(expandedState) {
            this.isSidebarOpen = expandedState;
        },
        onResize() {
            if (window.innerWidth < 992) {
                this.isSidebarOpen = false;
            }
        },
        hideSubsidebar() {
            // ...
        },
    }
}
</script>

<style scoped>
.layout-wrapper {
    display: flex;
    min-height: 100vh;
    width: 100%;
    /* Note: If the body has a background color, put it here. e.g., background: #f8f9fc; */
}

.main-content-wrapper {
    flex-grow: 1;
    margin-left: 70px; 
    width: calc(100% - 70px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 0; 
	height: 100vh;
    overflow-y: auto; /* This makes the wrapper the actual scrolling box */
    position: relative;
}

.main-content-wrapper.sidebar-expanded {
    margin-left: 260px; /* Make sure this matches your sidebar expanded width */
    width: calc(100% - 260px);
}

@media (max-width: 768px) {
    .main-content-wrapper,
    .main-content-wrapper.sidebar-expanded {
        margin-left: 0;
        width: 100%;
    }
}
</style>